export default Object.freeze({
  PENDING: 'pending'
})
